import deliveryImg from '../../assets/images/deliveryImg.png';
import SummaryBanner from './SummaryBanner';

const tipData: any = {
  1: {
    title: 'ALWAYS PROVIDE COMPLETE AND ACCURATE SHIPMENT DETAILS INCLUDING TYPE, LENGTH, WEIGHT, HEIGHT, WIDTH, VALUE, AND PURPOSE.',
    desc: 'This ensures proper handling, avoids customs delays, and helps you get accurate shipping rates, insurance coverage, and smooth delivery from start to finish.'
  },
  2: {
    title: 'Double-check the sender\'s details and pickup date before confirming your shipment.',
    desc: 'Accurate sender information ensures smooth pickup coordination, proper documentation, and reliable communication throughout the delivery process.'
  },
  3: {
    title: 'Always provide complete and correct receiver information',
    desc: 'Accurate recipient details help ensure successful delivery, reduce the risk of returned packages, and allow the courier to reach out if issues arise.'
  },
  5: {
      title: 'Provide a clear and accurate description of the items you\'re shipping.',
      desc: 'Use specific and accurate terms to describe your shipment contents, So as to clearly identify and describe the goods you intend to ship.'
  }
};

const DeliveryBanner = ({ tab }: { tab: number }) => {
  if (tab === 4) {
    return <SummaryBanner />;
  }
  const tip = Object.prototype.hasOwnProperty.call(tipData, tab) ? tipData[tab as keyof typeof tipData] : tipData[1];
  return (
    <div className='delivery-banner'>
      <div className="shipping-tips-section">
        <div className="tip-card blue-card">
          <h4 className="tip-heading">SHIPPING TIPS</h4>
          <h3 className="tip-title">{tip.title}</h3>
          <p className="tip-desc">{tip.desc}</p>
        </div>
        <div className="tip-card white-card">
          <h3 className="tip-title">ACROSS CITIES, STATES, AND COUNTRIES, WE DELIVER EVERYWHERE, ON TIME.</h3>
          <p className="tip-desc">From local errands to international shipments, our logistics network ensures your package arrives safely and swiftly.</p>
          <div className="tip-image">
            <img src={deliveryImg} alt="Delivery Illustration" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryBanner;